import { JsonDeserializable } from '../../rest/JsonDeserealizable';
import { Link } from './Link';

export const DEFAULT_POPUP_LINK = '';

export class LinkedEntityBase extends JsonDeserializable {
  orden: number = 0;
  titulo?: string;
  enlace?: Link;
  mensaje?: string;

  constructor(orden: number = 0, titulo?: string, enlace?: Link, mensaje?: string) {
    super();
    this.orden = orden;
    this.titulo = titulo;
    this.enlace = enlace;
    this.mensaje = mensaje;
  }

  static compareFn(a: LinkedEntityBase, b: LinkedEntityBase) {
    if (a == null || b == null) return;

    return a.orden - b.orden;
  }

  getUrl(): string | undefined {
    if (this.containsMessage()) return DEFAULT_POPUP_LINK;
    return this.enlace?.ruta?.trim();
  }

  getTag(): string | undefined {
    return this.enlace?.tag;
  }

  containsMessage(): boolean {
    return this.mensaje != null && this.mensaje.trim().length > 0;
  }

  containsLink(): boolean {
    return this.enlace != null && this.enlace.hasUrl();
  }

  hasNestedItems(): boolean {
    return false;
  }

  containsTitle(): boolean {
    return this.titulo != null && this.titulo.trim().length > 0;
  }

  static fromJsonObject(json: any): LinkedEntityBase {
    const enlace: Link | undefined = Link.fromJsonObject(json.enlace);
    return new LinkedEntityBase(json.orden, json.titulo, enlace, json.mensaje);
  }
}